<template>
  <div v-if="bookedColor !== ''" class="pop-up-content">
    <div
      v-bind:style="{ background: bookedColor }"
      class="pagination-buttons"
      v-if="mode !== 'approve_modal'"
    >
      <div>
        <span class="current-date"
          >{{ currentDate }} {{ getWeekDayName(this.currentDate) }}</span
        >
      </div>
      <div>
        <button
          @click.stop="closeCa"
          class="close-btn btn btn-success"
          :class="{ 'btn-warning': bookedColor === 'orange' }"
        >
          X
        </button>
      </div>
    </div>
    <!--    <div v-if="currentPage === 'calendar'">-->
    <div v-if="false">
      <CalendarComponent
        :mode="scheduleCalendarMode"
        :initial-date="currentDate"
        :events="calls"
        :shift="userShifts"
        @createCall="setTimes"
        @saveCall="applySc"
        @clickedCall="filterClient"
        @eventCanceled="eventCanceled"
      />
    </div>
    <div class="main-flex-tab-wrapper">
      <div class="flex-tab-wrapper">
        <div class="flex-tab-item loader-wrapper">
          <div v-if="fetchingCalls" class="loader"></div>
        </div>
        <div
          class="flex-tab-item"
          :class="{ active: selectedSchedTab === 'scheduleCalls' }"
          @click.stop="getScheduledCalls(null)"
        >
          <span
            >Schedule calls
            {{
              selectedSchedTab === "scheduleCalls" && calls.length > 0
                ? `(${calls.length})`
                : ""
            }}</span
          >
        </div>
        <div
          class="flex-tab-item"
          :class="{ active: selectedSchedTab === 'autoScheduleCalls' }"
          @click.stop="getScheduledCalls(1)"
        >
          <span
            >Auto-schedule calls
            {{
              selectedSchedTab === "autoScheduleCalls" && autoCalls.length > 0
                ? `(${autoCalls.length})`
                : ""
            }}</span
          >
        </div>
      </div>
      <div class="">
        <div class="" v-if="selectedSchedTab === 'scheduleCalls'">
          <CalendarComponent
            :mode="scheduleCalendarMode"
            :initial-date="currentDate"
            :events="calls"
            :shift="userShifts"
            @createCall="setTimes"
            @saveCall="applySc"
            @clickedCall="filterClient"
            @eventCanceled="eventCanceled"
            @setScrollLoading="loadingData"
          />
        </div>
      </div>
      <div class="">
        <div class="" v-if="selectedSchedTab === 'autoScheduleCalls'">
          <CalendarComponent
            :mode="scheduleCalendarMode"
            :initial-date="currentDate"
            :events="autoCalls"
            :shift="userShifts"
            @createCall="setTimes"
            @saveCall="applySc"
            @clickedCall="filterClient"
            @eventCanceled="eventCanceled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import apiClientCreator from "../../../../../../helpers/api/request";
import {mapGetters, mapState} from "vuex";
import CalendarComponent from "./calendar/CalendarComponent";
import GetDateTitles from "../../../../../../mixins/tags/GetDateTitles";
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "ScheduledCallsPopUp.component",
  components: { CalendarComponent },
  mixins: [UsersPermissionCheck, GetDateTitles, breadButtonsFunctionsUtil],
  data() {
    return {
      userShifts:[],
      selectedSchedTab: "scheduleCalls",
      scheduleCalendarMode: "add",
      currentDate: null,
      fromTime: null,
      toTime: null,
      calls: [],
      autoCalls: [],
      currentUserShift: null,
      bookedColor: "",
      scheduledCallReason: null,
      scheduledCallStatusReason: "Select reason/status",
      showScOptions: true,
      openSeg: true,
      scheduledCallComment: "",
      scheduledCallCommentError: "",
      scheduledCalls: [],
      currentPage: "calendar",
      prevButton: "Cancel",
      nextButton: "Next",
      autoRescheduled: null,
      fetchingCalls: false,
      scrolledToBottom: false,
      replaceClients:null,
      hoursFilters:[
        {
          id:0,
          data:false,
          scroll: 0,
          hours:{
            from:0,
            to:4,
          }
        },
        {
          id:1,
          data:false,
          scroll: 40,
          hours:{
            from:5,
            to:9,
          }
        },
        {
          id:2,
          data:false,
          scroll: 540,
          hours:{
            from:10,
            to:14,
          }
        },
        {
          id:3,
          data:false,
          scroll: 1040,
          hours:{
            from:15,
            to:19,
          }
        },
        {
          id:4,
          data:false,
          scroll: 1540,
          hours:{
            from:19,
            to:23,
          }
        },

      ],
      requests:{
        0:false,
        40:false,
        540:false,
        1040:false,
        1540:false,
      },
    };
  },

  props: {
    mode: {
      type: String
    },
    ifOpenViewMode: {
      type: Boolean
    },

    day: {
      type: String
    },
    week: {
      type: String
    },
    month: {
      type: String
    },
    year: {
      type: String
    },
    scheduleCallDate: {
      type: String
    },
    dateFromCalendar: {
      type: String
    },
    approvedCalls: {
      type: Object
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "openCaComponent",
      "loading"
    ])
  },
  created() {
    this.calculateDate();
    this.fetchScheduledCalls();
    this.scroll();
  },
  watch: {
    requests:{
      handler() {
        this.handleRequestsLoader()

      },
       deep:true
    },
    dateFromCalendar() {
      if (this.mode === "approve_modal") {
        this.currentDate = this.dateFromCalendar;
        this.calls = [];
        this.fetchScheduledCalls();
      }
    },
  },
  methods: {
    handleRequestsLoader(){
      let loader = false;
      Object.keys(this.requests).map(key => {
        if (this.requests[key]) {
          loader = true
        }
      });
      this.fetchingCalls = loader;
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.scrolledToBottom = true; // replace it with your code
        }
      };
    },
    loadingData(element){
      let hoursObj = this.getHoursLoadingData(parseInt(element))
      if(hoursObj && !hoursObj.data){
        this.fetchScheduledCalls(hoursObj)
      }
    },
    getHoursLoadingData(element){
      let objNum = 0;
      if(element >= 40 && element < 540 ){
        objNum = 40
      }
      if(element >= 540 && element < 1040 ){
        objNum = 540
      }
      if(element >= 1040 && element < 1540 ){
        objNum = 1040
      }
      if(element >= 1540){
        objNum = 1540
      }
      return this.hoursFilters.find(hour=>{
        return hour.scroll === objNum
      })
    },
    async getScheduledCalls(autoRescheduled) {
      //this.fetchingCalls = true;
      this.autoRescheduled = autoRescheduled;
      // this.calls = [];
      // this.autoCalls = [];
      // this.scheduledCalls = [];
      await this.fetchScheduledCalls();
      this.selectedSchedTab = autoRescheduled
        ? "autoScheduleCalls"
        : "scheduleCalls";
    },
    // async getScheduledCalls(){
    // this.autoRescheduled = null
    //  this.calls=[]
    //  await this.fetchScheduledCalls()
    //     this.selectedSchedTab = 'scheduleCalls';
    //   },
    async getAutoRescheduleCalls() {
      this.autoRescheduled = 1;
      this.calls = [];
      await this.fetchScheduledCalls();
      this.selectedSchedTab = "autoScheduleCalls";
    },
    goToPreviousPageAfterSelectingReason(reason) {
      // this.previousPage()

      let tempCreatedCall = this.calls.find(item => {
        return item.name === undefined;
      });
      tempCreatedCall.new = true;
      tempCreatedCall.name = `
      ${this.openCaComponent.clientObj.full_name}, ${this.openCaComponent.clientObj.country.name}, ${reason.type}
      `;
      // this.nextButton = "Apply";
    },

    async fetchScheduledCalls(hoursObj = null) {
      if(!hoursObj){
        hoursObj = this.hoursFilters[0];
      }
      if(hoursObj.data){
        return
      }
      if(this.requests[hoursObj.scroll]){
        return
      }

      let hourRange = {
        from: moment(
            hoursObj.hours.from.toString(),
            "LTS"
        ).format("HH:mm:ss"),
        to: moment(
            hoursObj.hours.to.toString(),
            "LTS").add(1,'hour').subtract(1,'second')
            .format("HH:mm:ss"),
      }
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 7, 12])) {
        try {
          this.requests[hoursObj.scroll] = true;
          this.$store.commit("clients/setLoading", true);
          let params = {
            date: this.currentDate,
            autoRescheduled: this.autoRescheduled,
            hr_from:hourRange.from,
            hr_to:hourRange.to,
          }
          if(this.openCaComponent.userId){
            params.user_id = this.openCaComponent.userId
          }
          const res = await apiClientCreator(
            `reports/scheduled_calls/specific_calls`
          ).get("", {
            params: params

          });
          this.requests[hoursObj.scroll] = false;
          this.$store.commit("clients/setLoading", false);
          this.scheduledCalls = res.data.calls;
          if (res.data.auto && this.scheduledCalls.length > 0) {
            this.selectedSchedTab = "autoScheduleCalls";
          }
          this.scheduledCalls.sort((a, b) => {
            return b.user_id - a.user_id;
          });
          // if (this.scheduledCalls.length > 0) {
            this.$emit("setIfOpenViewMode", true);
          // } else if (!this.autoRescheduled) {
          //   this.$emit("setIfOpenViewMode", false);
          // }
          //   let tempObject = this.openCaComponent;
          //   // tempObject.fromTable = false;
          //   tempObject.ifOpen = false;
          //   this.$store.commit("clients/setOpenCaComponent", tempObject);
          // }else{
          //   let tempObject = this.openCaComponent;
          //   // tempObject.fromTable = false;
          //   tempObject.ifOpen = true;
          //   this.$store.commit("clients/setOpenCaComponent", tempObject);
          // }
          this.scheduledCalls.forEach(call => {
            let user = this.getUserFromSalesPersonList(call["user_id"]);
            let event = {
              date: moment(call["scheduled_on"]).format("YYYY-MM-DD"),
              startTime: moment(call["scheduled_on"]).format("HH:mm:s"),
              endTime: moment(call["scheduled_on"])
                .add(15, "minutes")
                .format("HH:mm:s"),
              name: `| #${call["client_id"]} | ${call["client_full_name"]} | ${
                call["email"]
              } | ${this.addStatus(call["status_id"])}${this.addComment(
                call["comment"]
              )} | ${this.getClientCountry(call.country)} | ${user.full_name}
              ${moment(call["scheduled_on"])
                .format("llll")
                .slice(0, 17)}
              `,
              clientId: call["client_id"],
              user: user,
              is_auto:call['is_auto']
            };
            if (call['is_auto'] === 1) {
              this.autoCalls.push(event);
            }
              this.calls.push(event);

          });
          this.userShifts = res.data.shift
          this.calculateShiftBooked();
          //this.fetchingCalls = false;
          this.hoursFilters[hoursObj.id].data = true;
        } catch (e) {}
      }
    },
    getUserFromSalesPersonList(userId) {
      return this.salesPersonList.find(user => user.id === userId);
    },

    getAgentSc(user) {
      return "";
      // return this.auth.user.role !== 7 && user.role !== 1 && user.role !== 2
      //   ? `${user.full_name}`
      //   : "";
    },
    calculateDate() {
      if (this.scheduleCallDate) {
        this.currentDate = this.scheduleCallDate;
      } else {
        this.currentDate = this.dateFromCalendar;
      }
    },
    getClientCountry(countryId) {
      let country = this.dictionaries.general.countries.find(item => {
        return item.id === countryId;
      });
      // return country.name;
      return country.name ? country.name : country.alpha3;
    },
    addComment(comment) {
      return comment === null ? "" : " comm: " + comment;
    },
    addStatus(status, autoStatus) {
      if (status) {
        let tempStatus = this.dictionaries.activity.scheduled_calls_statuses.find(
          item => {
            return item.id === status;
          }
        );
        if (tempStatus) {
          return tempStatus.type;
        }
      }
      // else if (autoStatus) {
      //   return this.dictionaries.activity.scheduled_calls_auto_statuses.find(
      //     item => {
      //       return item.id === autoStatus;
      //     }
      //   ).type;
      // }
      else {
        return "";
      }
      // return status === null ? "" : status.type;
    },
    addEmail(email) {
      return email === null ? "" : email.contact_value.substring(0, 10) + "...";
    },
    calculateShiftBooked() {
      this.currentUserShift = this.dictionaries.general.global_shifts.find(
        item => {
          return item.shift_role_id === this.auth.user.role;
        }
      ).total_work_hours;
      let totalDiff = 0;
      this.calls.forEach(call => {
        let startTime = moment(call.date + " " + call.startTime);
        let endTime = moment(call.date + " " + call.endTime);
        totalDiff += endTime.diff(startTime, "minutes");
      });
      let userShiftInMinutes = this.currentUserShift * 60;
      let timeLeftInShift = userShiftInMinutes - totalDiff;
      if (timeLeftInShift < userShiftInMinutes * 0.34) {
        this.bookedColor = "red";
      } else if (
        timeLeftInShift >= userShiftInMinutes * 0.34 &&
        timeLeftInShift < userShiftInMinutes * 0.9
      ) {
        this.bookedColor = "orange";
      } else {
        this.bookedColor = "green";
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    async applySc() {
       await this.scheduleCall();
      this.addFakeTag(this.openCaComponent.clientId, 10000);
      this.closeCa();
      this.$emit("fetchScStats");
    },
    addFakeTag(clientId, interval) {
      // let keySC = this.openCaComponent.clientId;
      let keySC = clientId;
      let ti = {
        ...this.SCTimer,
        [keySC]: setTimeout(async () => {
          let tempObj = Object.assign({}, this.SCTimer);
          delete tempObj[keySC];
          this.$store.commit("clients/setSCTimer", tempObj);
        }, interval)
      };
      this.$store.commit("clients/setSCTimer", ti);
    },
    nextPage() {
      switch (this.currentPage) {
        case "summary":
          this.scheduleCall();
          this.closeCa();
          break;
        case "reasons":
          this.nextButton = "Apply";
          this.currentPage = "summary";
          break;
        case "calendar":
          this.prevButton = "Back";
          this.currentPage = "reasons";
          break;
      }
    },
    previousPage() {
      switch (this.currentPage) {
        case "summary":
          this.nextButton = "Next";
          this.currentPage = "reasons";
          this.scheduledCallCommentError = "";
          break;
        case "reasons":
          this.currentPage = "calendar";
          this.prevButton = "Cancel";
          break;
        case "calendar":
          this.closeCa();
          break;
      }
    },
    closeCa() {
      this.$store.commit("clients/setOpenCaComponent", {
        ifOpen: false,
        clientId: null,
        date: null,
        fromTable: this.currentDate === null
      });
      // this.$emit('fetchScStats')
    },
    eventCanceled() {
      this.calls = this.calls.filter(item => {
        return item.new !== true;
      });
    },
    setTimes(dateWithTime, reason, comment,replaceClients) {
      this.replaceClients = replaceClients;
      this.fromTime = dateWithTime.startTime;
      this.toTime = dateWithTime.endTime;
      this.scheduledCallReason = reason;
      this.scheduledCallComment = comment;
      let tempCreatedCall;
      if (this.autoRescheduled) {
        tempCreatedCall = this.autoCalls.find(item => {
          return item.name === undefined;
        });
      } else {
        tempCreatedCall = this.calls.find(item => {
          return item.name === undefined;
        });
      }

      // if(tempCreatedCall){
      tempCreatedCall.new = true;
      tempCreatedCall.name = `${this.openCaComponent.clientObj.full_name} | ${this.openCaComponent.clientObj.country.name} | ${reason.type} | ${comment}`;
      // }
      // this.nextPage()
    },
    filterClient(event) {
      // this.filterClientById(event.clientId);
      if (this.mode !== "approve_modal") {
        this.filterSCByToday(event.date);
        this.addFakeTag(event.clientId, 15000);
      }
    },
    filterClientById(clientId) {
      this.$store.commit("clients/setFilterClientById", clientId);
    },
    filterSCByToday(date) {
      this.$emit("filterSCByToday", date);
    },

    async scheduleCall() {
      if (this.fromTime === null || this.toTime === null) {
        this.scheduledCallCommentError = "Please Select Time";
        return;
      }
      if (this.scheduledCallReason === null) {
        this.scheduledCallCommentError = "Please Select Reason/Status";
        return;
      }
      let newScheduledCall = {
        call_scheduled_on: moment(
          this.currentDate + " " + this.fromTime
        ).format("YYYY-MM-DD HH:mm:ss"),
        comment: this.scheduledCallComment,
        status_id: this.scheduledCallReason.id,
        priority_id: 3
      };
      if(this.replaceClients){
        newScheduledCall = {...newScheduledCall,replace_id:this.replaceClients}
      }
      let clientId = this.openCaComponent.clientId;
      try {
        this.$store.commit("clients/setLoading", true);
        const apiClient = apiClientCreator(
          `client/schedule-call/${clientId}`,
          "token"
        );

        await apiClient.post("", newScheduledCall).then(res => {});
        //this.$emit("updated");

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Scheduled Call\n Completed",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.scheduledCall = null;
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Schedule Call Tagging Error!  Status:" + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
    }
  },
  mounted() {
    //  Function temporary disabled
    //   if(this.mode === 'add'){
    //   this.triggerPreset("CA_F", 'MONTH');
    //   this.$store.commit('clients/setSelectedTopTag','CA')
    //   }
  }
};
</script>

<style>
.pop-up-content {
  /*opacity: 0.7;*/
}
.pop-up-content .input-sc-status {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  margin-top: 5px;
  margin-bottom: 5px;
  /*border-radius: 5px;*/
  margin-left: 0 !important;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  box-sizing: border-box;
  background-color: #ed7014 !important;
}
.sc-reasons {
  padding: 1em;
}
.pop-up-content .lang-dropdown {
  padding: 5px;
  height: 384px;
  width: 340px;
  overflow-x: hidden;
  margin-bottom: 10px;
}
.pop-up-content .lang-dropdown li {
  list-style-type: none;
}

.add-tag-menu-item {
  margin: 6px;
  font-size: 12px !important;
  text-transform: uppercase !important;
}
.add-tag-menu-item:nth-child(odd) {
  background-color: #f3f2f2;
  padding: 5px;
}

.add-tag-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
/*.add-tag-menu-item:active, .add-tag-menu-item:focus  {*/
/*  background: greenyellow;*/
/*  color: red;*/
/*  cursor: pointer;*/
/*}*/

.pop-up-content .calendar-container .v-cal {
  height: 550px !important;
  width: 1042px;
  /*width: 1221px;*/
}
.pop-up-content .calendar-container .v-cal-days__wrapper,
.pop-up-content .calendar-container .v-cal-day.v-cal-day--day.is-today {
  width: 100%;
}
.pop-up-content .calendar-container .v-cal .v-cal-header {
  display: none;
}
.pop-up-content .calendar-container .v-cal .v-cal-hour,
.pop-up-content .calendar-container .v-cal .v-cal-day__hour-block {
  /*height: 65px !important;*/
  height: 100px !important;
}

.pop-up-content .calendar-container .v-cal-times {
  width: 10%;
}

.pop-up-content .calendar-container .v-cal-days__wrapper {
  width: 90%;
}

.sc-summary {
  padding: 2em;
  width: 350px;
  height: 370px;
}
.summary-data {
  display: flex;
  justify-content: space-between;
  padding: 1.5em 0;
}
.summary-times {
  padding-right: 5em;
}
.summary-title {
  font-weight: bold;
  font-size: 15px;
}
.pop-up-content .bttn {
  width: fit-content;
  font-size: 12px;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #efefef !important;
  color: black;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-family: "Montserrat" !important;
  cursor: pointer;
}
.sc-pagination {
  padding: 1em 2em;
  display: flex;
  flex-direction: column;
}
.pagination-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-btn {
  margin: 0.5em 1em;
  padding: 0.3em 0.5em;
}
.pop-up-content .v-cal-event-time {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.pop-up-content .v-cal-event-name {
  font-size: 0.85rem !important;
  white-space: pre-line;
}
.pop-up-content .v-cal-day__hour-block {
  overflow: visible;
}
.pagination-buttons button.btn.btn-success {
  margin-right: 5px;
}
.v-cal-content .v-cal-event-item .v-cal-event-name {
  /*margin-left: 5px;*/
  font-size: 13px !important;
}
.v-cal-event-item {
  transition: all 0.3s ease-in-out !important;

  /*min-width: 150px !important;*/
  /*height: max-content!important;*/
}
.v-cal-event-item:hover {
  /*transform: scale(1.05);*/
  transform: scaleY(1.3);
  z-index: 2 !important;
  /*height: max-content!important;*/
  height: max-content !important;
  /*min-height: 42px !important;*/
  /*z-index: 10999999999999999999999!important;*/
  min-width: 200px !important;

  /*width: max-content!important;*/
  /*position:absolute !important;*/
}
.v-cal-event-item.is-overlapping:hover {
  /*z-index: 2222222222222222222222222222222222222222222222!important;*/
}
.selected-reason {
  background-color: #c1c1c1;
}
.v-cal-dialog-card {
  max-width: 400px !important;
}
/*.v-cal-day__hour-block*/
/*{*/
/*  background-image: linear-gradient(0deg, #bdbbbf 25%, #e9e8eb 25%, #e9e8eb 50%, #bdbbbf 50%, #bdbbbf 75%, #e9e8eb 75%, #e9e8eb 100%);*/
/*  background-size: 100.00px 100.00px;*/
/*}*/
.v-cal-content .v-cal-event-item::after {
  /*content: "";*/
  /*display: block;*/
  /*position: absolute;*/
  /*width: 14px;*/
  /*height: 100%;*/
  /*top: 0;*/
  /*right: 0;*/
  background: none !important;
}
.v-cal-dialog .v-cal-dialog-card__body {
  padding: 0px !important;
}
.current-date {
  color: white;
  padding: 20px;
  margin-top: 10px;
}
.v-cal-event-time {
  font-size: 12px !important;
  font-weight: 500 !important;
}
.pop-up-content div {
  cursor: default;
}
.main-flex-tab-wrapper span {
  cursor: pointer;
}

.flex-tab-wrapper {
  display: flex;
  /*margin-left: 15%;*/
  margin-top: 1%;
}
.flex-tab-item {
  position: relative;
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer !important;
}
.flex-tab-item.active {
  color: #0d6aad;
  border-bottom: #0d6aad 2px solid;
}
.flex-tab-item:hover {
  color: #0d6aad;
}
.loader {
  position: absolute;
  top: 400px;
  z-index: 30;
  right: -362px;
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin-top: -16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
div.loader-wrapper {
  flex: 0.4;
}
</style>
